import { render } from "./Evaluation2.vue?vue&type=template&id=02d91d16"
import script from "./Evaluation2.vue?vue&type=script&lang=js"
export * from "./Evaluation2.vue?vue&type=script&lang=js"
script.render = render

export default script